/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

/*  Components  */
import { AnmTab } from '../../Components/AnmTab';
import { IconForSidebarListItem } from './SidebarIcons';
import { SidebarListItem } from './SidebarListItem';

/**
 * Component that renders a return navigation element in the sidebar
 * @component
 * @param {Object} props - Component props
 * @param {() => void} props.handleReturnToPartnerHub - Callback function to handle returning to partner hub
 * @param {boolean} props.renderAdminLinks - Flag to determine if admin links should be rendered
 * @returns {JSX.Element} Sidebar return navigation component
 */
export const SidebarReturnTo = ({
    handleReturnToPartnerHub,
    renderAdminLinks
}: {
    handleReturnToPartnerHub: () => void;
    renderAdminLinks: boolean;
}) => {
    const { t } = useTranslation();
    const { partnerId } = useParams();

    return (
        <Box
            data-testid="sidebarReturnTo"
            data-trackid="sidebarReturnTo"
            style={{ display: 'flex', flexDirection: 'column' }}
        >
            {!renderAdminLinks && <AnmTab />}
            {renderAdminLinks && partnerId && (
                <SidebarListItem
                    bottomItem
                    icon={<IconForSidebarListItem src="UndoSmallArrow" />}
                    name={t('Common.partner_hub')}
                    onClick={handleReturnToPartnerHub}
                    permission={['partner', 'system_admin']}
                    permissionOperator="and"
                    route={`/partner/${partnerId}/organizations`}
                />
            )}
        </Box>
    );
};
